import { Image } from '@domain-group/suit-theme'

import placeholderImageUrl from './assets/placeholder.svg'

interface IntegrationPlatformLogoProps {
  boxProps?: object,
  imageProps?: object,
  integrationPlatformKey: string,
  logoUrl?: string,
  size?: string,
}

const IntegrationPlatformLogo = (props: IntegrationPlatformLogoProps) => {
  const {
    boxProps, imageProps, integrationPlatformKey, logoUrl, size,
  } = props

  if (!integrationPlatformKey){
    return null
  }

  return (
    <Image
      boxProps={{ padding: size === 'large' ? 'xlarge' : 'medium', ...boxProps }}
      placeholderUrl={placeholderImageUrl}
      style={{ backgroundOrigin: 'content-box' }}
      url={logoUrl}
      {...imageProps}
    />
  )
}

export default IntegrationPlatformLogo
